import { useMemo, useState } from 'react';
import type { PropsWithChildren } from 'react';
import { ScannerPanelContext, type ScannerPanelContextType } from './ScannerPanelContext.context';

export function ScannerPanelProvider({ children }: PropsWithChildren) {
	const [open, setOpen] = useState(false);
	const [prefillQuery, setPrefillQuery] = useState('');

	const api = useMemo<ScannerPanelContextType>(
		() => ({
			open,
			openPanel: () => setOpen(true),
			closePanel: () => setOpen(false),
			togglePanel: () => setOpen((v) => !v),
			setPrefillQuery: setPrefillQuery,
			prefillQuery
		}),
		[open, prefillQuery]
	);

	return <ScannerPanelContext.Provider value={api}>{children}</ScannerPanelContext.Provider>;
}
